
/**
 * A function that returns the URL part common to the endpoints.
 */
export const root = () => {
    let __root = "";
    
    if (process.env.RUNTIME_ENV === "local") {       
        __root = "https://api-users.dev.m2msystems.cloud";
    }

    if (process.env.RUNTIME_ENV === "localDev") {       
        __root = "https://api-users.dev.m2msystems.cloud";
    }

    if (process.env.RUNTIME_ENV === "development") {       
        __root = "https://api-users.dev.m2msystems.cloud";
    }

    if (process.env.RUNTIME_ENV === "production") {       
        __root = "https://api-users.m2msystems.cloud";
    }
    return __root
}

/**
 * ヘルスチェック
 * 
 */
export const healthCheck = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/health_check`;
    return __queries ? `${__path}?${__queries}` : __path;
};
healthCheck.method = "GET" as const;
healthCheck.authSchema = {"type":"","header":""} as const;

/**
 * RFC 7517準拠のJWKセットを取得する
 * 
 */
export const getWellKnownJwks = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/.well-known/jwks.json`;
    return __queries ? `${__path}?${__queries}` : __path;
};
getWellKnownJwks.method = "GET" as const;
getWellKnownJwks.authSchema = {"type":"","header":""} as const;

/**
 * OIDC Discovery 1.0 の provider metadata を取得する
 * 
 */
export const getWellKnownOpenIDConfiguration = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/.well-known/openid-configuration`;
    return __queries ? `${__path}?${__queries}` : __path;
};
getWellKnownOpenIDConfiguration.method = "GET" as const;
getWellKnownOpenIDConfiguration.authSchema = {"type":"","header":""} as const;

/**
 * 会社を一覧取得する
 * 
 */
export const getCompanies = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/companies`;
    return __queries ? `${__path}?${__queries}` : __path;
};
getCompanies.method = "GET" as const;
getCompanies.authSchema = {"type":"","header":""} as const;

/**
 * 会社の一覧を返す
 * 
 */
export const listCompanies = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/companies/list`;
    return __queries ? `${__path}?${__queries}` : __path;
};
listCompanies.method = "GET" as const;
listCompanies.authSchema = {"type":"","header":""} as const;

/**
 * 会社を作成する
 * 
 */
export const createCompany = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/companies/`;
    return __queries ? `${__path}?${__queries}` : __path;
};
createCompany.method = "POST" as const;
createCompany.authSchema = {"type":"","header":""} as const;

/**
 * 会社情報を取得する
 * 
 */
export const getCompany = ({id}: {id: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/companies/${id}`;
    return __queries ? `${__path}?${__queries}` : __path;
};
getCompany.method = "GET" as const;
getCompany.authSchema = {"type":"","header":""} as const;

/**
 * 会社情報を更新する
 * 
 */
export const updateCompany = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/companies/`;
    return __queries ? `${__path}?${__queries}` : __path;
};
updateCompany.method = "PUT" as const;
updateCompany.authSchema = {"type":"","header":""} as const;

/**
 * 会社情報を更新する
 * 
 */
export const updateCompanyPatch = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/companies/`;
    return __queries ? `${__path}?${__queries}` : __path;
};
updateCompanyPatch.method = "PATCH" as const;
updateCompanyPatch.authSchema = {"type":"","header":""} as const;

/**
 * idを指定して複数の会社情報を取得する
 * @param {string} company_ids a,b,c
 */
export const findCompaniesByIds = ({company_ids}: {company_ids?: string}) => {
    const __root = root();
    const __queries = Object.entries({company_ids})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/companies/find_by_ids`;
    return __queries ? `${__path}?${__queries}` : __path;
};
findCompaniesByIds.method = "GET" as const;
findCompaniesByIds.authSchema = {"type":"","header":""} as const;

/**
 * ユーザーを作成する
 * 
 */
export const createUser = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/users/`;
    return __queries ? `${__path}?${__queries}` : __path;
};
createUser.method = "POST" as const;
createUser.authSchema = {"type":"","header":""} as const;

/**
 * ユーザーを取得する
 * 
 */
export const findUserById = ({id}: {id: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/users/${id}`;
    return __queries ? `${__path}?${__queries}` : __path;
};
findUserById.method = "GET" as const;
findUserById.authSchema = {"type":"","header":""} as const;

/**
 * ユーザーを更新する
 * 
 */
export const updateUser = ({id}: {id: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/users/${id}`;
    return __queries ? `${__path}?${__queries}` : __path;
};
updateUser.method = "PUT" as const;
updateUser.authSchema = {"type":"","header":""} as const;

/**
 * ユーザーを更新する
 * 
 */
export const updateUserPatch = ({id}: {id: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/users/${id}`;
    return __queries ? `${__path}?${__queries}` : __path;
};
updateUserPatch.method = "PATCH" as const;
updateUserPatch.authSchema = {"type":"","header":""} as const;

/**
 * ユーザーを強制的に有効化する
 * 
 */
export const activateUserByAdmin = ({id}: {id: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/users/${id}/admin_activate`;
    return __queries ? `${__path}?${__queries}` : __path;
};
activateUserByAdmin.method = "POST" as const;
activateUserByAdmin.authSchema = {"type":"","header":""} as const;

/**
 * ユーザーを無効化する
 * 
 */
export const deactivateUser = ({id}: {id: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/users/${id}/deactivate`;
    return __queries ? `${__path}?${__queries}` : __path;
};
deactivateUser.method = "POST" as const;
deactivateUser.authSchema = {"type":"","header":""} as const;

/**
 * パスワードリセットのメールを送信する
 * 
 */
export const sendResetPasswordEmail = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/users/reset_password_email`;
    return __queries ? `${__path}?${__queries}` : __path;
};
sendResetPasswordEmail.method = "POST" as const;
sendResetPasswordEmail.authSchema = {"type":"","header":""} as const;

/**
 * パスワードをリセットする
 * 
 */
export const resetPassword = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/users/reset_password`;
    return __queries ? `${__path}?${__queries}` : __path;
};
resetPassword.method = "POST" as const;
resetPassword.authSchema = {"type":"","header":""} as const;

/**
 * アクティベーションメールを送信する
 * 
 */
export const sendActivationEmail = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/users/activation_email`;
    return __queries ? `${__path}?${__queries}` : __path;
};
sendActivationEmail.method = "POST" as const;
sendActivationEmail.authSchema = {"type":"","header":""} as const;

/**
 * ユーザーを有効化する
 * 
 */
export const activateUser = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/users/activate`;
    return __queries ? `${__path}?${__queries}` : __path;
};
activateUser.method = "POST" as const;
activateUser.authSchema = {"type":"","header":""} as const;

/**
 * 認可スコープを設定する
 * 
 */
export const setAuthorityScope = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/users/scope`;
    return __queries ? `${__path}?${__queries}` : __path;
};
setAuthorityScope.method = "PUT" as const;
setAuthorityScope.authSchema = {"type":"","header":""} as const;

/**
 * メールを指定してユーザーを取得する
 * 
 */
export const findUserByEmail = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/users/find_by_email`;
    return __queries ? `${__path}?${__queries}` : __path;
};
findUserByEmail.method = "POST" as const;
findUserByEmail.authSchema = {"type":"","header":""} as const;

/**
 * ユーザーの権限を更新する
 * 
 */
export const updateAuthority = ({id}: {id: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/users/authority/${id}`;
    return __queries ? `${__path}?${__queries}` : __path;
};
updateAuthority.method = "PUT" as const;
updateAuthority.authSchema = {"type":"","header":""} as const;

/**
 * companyIdからユーザーを取得する
 * @param {string} statuses BeforeVerification,Active,Deactivated
 */
export const findUsersByCompanyId = ({statuses}: {statuses?: string}) => {
    const __root = root();
    const __queries = Object.entries({statuses})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/users/find_by_company_id`;
    return __queries ? `${__path}?${__queries}` : __path;
};
findUsersByCompanyId.method = "GET" as const;
findUsersByCompanyId.authSchema = {"type":"","header":""} as const;

/**
 * ユーザー情報をAdminが変更する
 * 
 */
export const updateUserByAdmin = ({id}: {id: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/users/${id}/admin_update`;
    return __queries ? `${__path}?${__queries}` : __path;
};
updateUserByAdmin.method = "PUT" as const;
updateUserByAdmin.authSchema = {"type":"","header":""} as const;

/**
 * ユーザーの会社を移動する
 * 
 */
export const transferUserCompany = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/users/transfer_company`;
    return __queries ? `${__path}?${__queries}` : __path;
};
transferUserCompany.method = "POST" as const;
transferUserCompany.authSchema = {"type":"","header":""} as const;

/**
 * ログインする
 * 
 */
export const login = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/login`;
    return __queries ? `${__path}?${__queries}` : __path;
};
login.method = "POST" as const;
login.authSchema = {"type":"","header":""} as const;

/**
 * ログインする
 * 
 */
export const loginWithSlash = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/login/`;
    return __queries ? `${__path}?${__queries}` : __path;
};
loginWithSlash.method = "POST" as const;
loginWithSlash.authSchema = {"type":"","header":""} as const;

/**
 * JWKを取得する
 * 
 */
export const getJwks = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/login/jwks`;
    return __queries ? `${__path}?${__queries}` : __path;
};
getJwks.method = "GET" as const;
getJwks.authSchema = {"type":"","header":""} as const;

/**
 * 公開鍵を取得する
 * 
 */
export const getPublicKeys = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/login/public_keys`;
    return __queries ? `${__path}?${__queries}` : __path;
};
getPublicKeys.method = "GET" as const;
getPublicKeys.authSchema = {"type":"","header":""} as const;

/**
 * MFAのコードを発行する
 * 
 */
export const publishMFACode = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/login/publish_mfa_code`;
    return __queries ? `${__path}?${__queries}` : __path;
};
publishMFACode.method = "POST" as const;
publishMFACode.authSchema = {"type":"","header":""} as const;

/**
 * MFAを使ってログインする
 * 
 */
export const loginWithMFA = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/login/mfa_login`;
    return __queries ? `${__path}?${__queries}` : __path;
};
loginWithMFA.method = "POST" as const;
loginWithMFA.authSchema = {"type":"","header":""} as const;

/**
 * トークンを取得する
 * 
 */
export const getToken = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/login/token`;
    return __queries ? `${__path}?${__queries}` : __path;
};
getToken.method = "POST" as const;
getToken.authSchema = {"type":"","header":""} as const;

/**
 * Google OAuth 2.0 の認可URLへリダイレクトする(Google ログイン PoC)
 * @param {string} redirect_uri <ログイン成功後にブラウザを戻す先(allowlist登録必須)>
 */
export const authorizeGoogleLogin = ({redirect_uri}: {redirect_uri?: string}) => {
    const __root = root();
    const __queries = Object.entries({redirect_uri})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/login/google/authorize`;
    return __queries ? `${__path}?${__queries}` : __path;
};
authorizeGoogleLogin.method = "GET" as const;
authorizeGoogleLogin.authSchema = {"type":"","header":""} as const;

/**
 * Googleからのコールバックを検証し、ログインする(Google ログイン PoC)
 * @param {string} code <Googleの認可コード>
 * @param {string} state <CSRF用state>
 */
export const googleLoginCallback = ({code, state}: {code?: string, state?: string}) => {
    const __root = root();
    const __queries = Object.entries({code, state})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/login/google/callback`;
    return __queries ? `${__path}?${__queries}` : __path;
};
googleLoginCallback.method = "GET" as const;
googleLoginCallback.authSchema = {"type":"","header":""} as const;

/**
 * ログイン済みユーザーが自分の Google アカウントを link するための認可URLを取得する
 * 
 */
export const authorizeGoogleLink = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/link/google/authorize`;
    return __queries ? `${__path}?${__queries}` : __path;
};
authorizeGoogleLink.method = "POST" as const;
authorizeGoogleLink.authSchema = {"type":"","header":""} as const;

/**
 * Googleからのコールバックを検証し、Google アカウントを link する
 * @param {string} code <Googleの認可コード>
 * @param {string} state <CSRF用state>
 */
export const googleLinkCallback = ({code, state}: {code?: string, state?: string}) => {
    const __root = root();
    const __queries = Object.entries({code, state})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/link/google/callback`;
    return __queries ? `${__path}?${__queries}` : __path;
};
googleLinkCallback.method = "GET" as const;
googleLinkCallback.authSchema = {"type":"","header":""} as const;

/**
 * OIDC の認可エンドポイント。リクエストを検証しログインフォームを表示する
 * @param {string} client_id <client_id>
 * @param {string} redirect_uri <登録済みredirect_uri(完全一致)>
 * @param {string} response_type code
 * @param {string} scope <scope>
 * @param {string} state <state>
 * @param {string} nonce <nonce>
 * @param {string} code_challenge <PKCE S256 challenge>
 * @param {string} code_challenge_method S256
 */
export const oidcAuthorize = ({client_id, redirect_uri, response_type, scope, state, nonce, code_challenge, code_challenge_method}: {client_id?: string, redirect_uri?: string, response_type?: string, scope?: string, state?: string, nonce?: string, code_challenge?: string, code_challenge_method?: string}) => {
    const __root = root();
    const __queries = Object.entries({client_id, redirect_uri, response_type, scope, state, nonce, code_challenge, code_challenge_method})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/oidc/authorize`;
    return __queries ? `${__path}?${__queries}` : __path;
};
oidcAuthorize.method = "GET" as const;
oidcAuthorize.authSchema = {"type":"","header":""} as const;

/**
 * OIDC のログインフォームの送信先。認証成功時に認可コードを発行して redirect_uri へリダイレクトする
 * 
 */
export const oidcAuthorizeLogin = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/oidc/authorize`;
    return __queries ? `${__path}?${__queries}` : __path;
};
oidcAuthorizeLogin.method = "POST" as const;
oidcAuthorizeLogin.authSchema = {"type":"","header":""} as const;

/**
 * OIDC のトークンエンドポイント。認可コード + PKCE の検証と id_token / access_token / refresh_token の発行、refresh token の rotation を行う
 * 
 */
export const oidcToken = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/oidc/token`;
    return __queries ? `${__path}?${__queries}` : __path;
};
oidcToken.method = "POST" as const;
oidcToken.authSchema = {"type":"","header":""} as const;

/**
 * OIDC の UserInfo エンドポイント。Authorization: Bearer <access_token> を検証し sub を返す
 * 
 */
export const oidcUserInfo = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/oidc/userinfo`;
    return __queries ? `${__path}?${__queries}` : __path;
};
oidcUserInfo.method = "GET" as const;
oidcUserInfo.authSchema = {"type":"","header":""} as const;

/**
 * OIDC のトークン失効エンドポイント(RFC 7009)。client_id + token(+ token_type_hint)を検証し refresh_token を失効させる(access_token も受理するが self-contained JWT のため自然失効まで有効であり得る)
 * 
 */
export const oidcRevoke = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/oidc/revoke`;
    return __queries ? `${__path}?${__queries}` : __path;
};
oidcRevoke.method = "POST" as const;
oidcRevoke.authSchema = {"type":"","header":""} as const;

/**
 * RP-Initiated Logout(#1087)。本 OP はブラウザセッションを持たないため、実体は id_token_hint(iss/署名検証済み)で特定した client/user の refresh token 一括失効
 * @param {string} id_token_hint <OP発行のid_token>
 * @param {string} client_id <audが単一要素なら省略可・複数要素なら必須>
 * @param {string} post_logout_redirect_uri <登録済みredirect_uriと完全一致する場合のみ使用>
 * @param {string} state <リダイレクト時にそのまま付与>
 */
export const oidcEndSession = ({id_token_hint, client_id, post_logout_redirect_uri, state}: {id_token_hint?: string, client_id?: string, post_logout_redirect_uri?: string, state?: string}) => {
    const __root = root();
    const __queries = Object.entries({id_token_hint, client_id, post_logout_redirect_uri, state})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/oidc/end_session`;
    return __queries ? `${__path}?${__queries}` : __path;
};
oidcEndSession.method = "GET" as const;
oidcEndSession.authSchema = {"type":"","header":""} as const;

/**
 * RP-Initiated Logout(#1087)。GET /oidc/end_session と同じ処理を POST(application/x-www-form-urlencoded)で受け付ける
 * 
 */
export const oidcEndSessionPost = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/oidc/end_session`;
    return __queries ? `${__path}?${__queries}` : __path;
};
oidcEndSessionPost.method = "POST" as const;
oidcEndSessionPost.authSchema = {"type":"","header":""} as const;

/**
 * ログイン中のユーザー自身の、指定 client_id(OIDC の RP)に紐づく refresh token をすべて失効させる
 * 
 */
export const revokeRefreshTokensByClient = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/refresh_tokens/revoke_by_client`;
    return __queries ? `${__path}?${__queries}` : __path;
};
revokeRefreshTokensByClient.method = "POST" as const;
revokeRefreshTokensByClient.authSchema = {"type":"","header":""} as const;

/**
 * 指定ユーザー(省略時は本人)の refresh token をすべて失効させる。他ユーザー指定は Admin 以上かつ同一会社のみ
 * 
 */
export const revokeRefreshTokensByUser = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/refresh_tokens/revoke_by_user`;
    return __queries ? `${__path}?${__queries}` : __path;
};
revokeRefreshTokensByUser.method = "POST" as const;
revokeRefreshTokensByUser.authSchema = {"type":"","header":""} as const;

/**
 * usersに存在しないアカウントのトークンを作成する(deprecated)
 * 
 */
export const generateToken = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/guest/token`;
    return __queries ? `${__path}?${__queries}` : __path;
};
generateToken.method = "POST" as const;
generateToken.authSchema = {"type":"","header":""} as const;

/**
 * usersに存在しないアカウントのトークンを作成する
 * 
 */
export const generateUserToken = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/generate/token`;
    return __queries ? `${__path}?${__queries}` : __path;
};
generateUserToken.method = "POST" as const;
generateUserToken.authSchema = {"type":"","header":""} as const;

/**
 * 会社のアクティベーションメールを再送する(matsuriAdmin用)
 * 
 */
export const matsuriAdminSendCompanyActivationMail = ({id}: {id: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/matsuriAdmin/companies/${id}/send_activation_mail`;
    return __queries ? `${__path}?${__queries}` : __path;
};
matsuriAdminSendCompanyActivationMail.method = "POST" as const;
matsuriAdminSendCompanyActivationMail.authSchema = {"type":"","header":""} as const;
export const m2mUsers_v1 = {healthCheck,getWellKnownJwks,getWellKnownOpenIDConfiguration,getCompanies,listCompanies,createCompany,getCompany,updateCompany,updateCompanyPatch,findCompaniesByIds,createUser,findUserById,updateUser,updateUserPatch,activateUserByAdmin,deactivateUser,sendResetPasswordEmail,resetPassword,sendActivationEmail,activateUser,setAuthorityScope,findUserByEmail,updateAuthority,findUsersByCompanyId,updateUserByAdmin,transferUserCompany,login,loginWithSlash,getJwks,getPublicKeys,publishMFACode,loginWithMFA,getToken,authorizeGoogleLogin,googleLoginCallback,authorizeGoogleLink,googleLinkCallback,oidcAuthorize,oidcAuthorizeLogin,oidcToken,oidcUserInfo,oidcRevoke,oidcEndSession,oidcEndSessionPost,revokeRefreshTokensByClient,revokeRefreshTokensByUser,generateToken,generateUserToken,matsuriAdminSendCompanyActivationMail};
